import pluginSource from './_plugin/jm.js?raw';
import { createJmcomicSource } from './source.ts';

export * from './source.ts';

export const source = createJmcomicSource({ jsSource: pluginSource });

export default source;
